import axios from 'axios'

const loco = window.location
const appRootUrl = `${loco.protocol}//${loco.host}${process.env.BASE_URL}`
const configUrl = appRootUrl + 'static/config.json'

var config
const readConfig = new Promise(function (resolve, reject) {
    axios.get(configUrl)
        .then(r => {
            config = r.data
            resolve(true)
        }).catch(r => {
            console.log(r);
            reject(new Error('Failed to read config'))
        })
})

export {
    readConfig,
    config
}